import {
  AudioOutlined,
  BellOutlined,
  CalendarOutlined,
  CloseCircleOutlined,
  CustomerServiceOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  FileTextOutlined,
  InboxOutlined,
  LockOutlined,
  MailOutlined,
  PauseCircleOutlined,
  PhoneOutlined,
  ProfileOutlined,
  QuestionCircleOutlined,
  ReloadOutlined,
  RobotOutlined,
  SendOutlined,
  SoundOutlined,
  TagsOutlined,
  UnlockOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import { ContactHistoryType } from "@leedpulse-monorepo/enums";

export const contactHistoryTypeAsIcon = (contactHistoryType: ContactHistoryType | string): React.ReactNode => {
  switch (contactHistoryType) {
    case ContactHistoryType.email:
      return <MailOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.mobilepush:
      return <PhoneOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.scenarioupdate:
      return <ReloadOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.calltranscript:
    case ContactHistoryType.call:
      return <PhoneOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.updatemanualinfo:
      return <EditOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.qualification:
    case ContactHistoryType.updatebyiainfo:
      return <RobotOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.messagereceived:
      return <InboxOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.messagesent:
      return <SendOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.datadeletionrequest:
      return <ExclamationCircleOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.contactexist:
      return <CloseCircleOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.phoneexist:
      return <ProfileOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.aipaused:
      return <PauseCircleOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.taskcreated:
      return <CalendarOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.taskupdated:
      return <EditOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.notificationupdate:
      return <BellOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.updatedbyleedflow:
      return <SoundOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.voicemailreceived:
      return <AudioOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.note:
      return <FileTextOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.receptionist:
      return <CustomerServiceOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.whatsappsent:
    case ContactHistoryType.whatsappreceived:
    case ContactHistoryType.whatsappsummary:
      return <WhatsAppOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.tagsupdatedbyia:
      return <TagsOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.confidentialenabled:
      return <LockOutlined style={{ marginRight: 6 }} />
    case ContactHistoryType.confidentialdisabled:
      return <UnlockOutlined style={{ marginRight: 6 }} />
    default:
      return <QuestionCircleOutlined style={{ marginRight: 6 }} />
  }
};
